export interface menu {
    header?: string;
    title?: string;
    children?: menu[];
    to?: string;
}

const sidebarItem: menu[] = [
    {
        title: 'Home',
        to: '/'
    },
    {
        title: 'Features',
        children: [
            {
                title: 'AI Content Creation',
                to: '/features/content-creation'
            },
            {
                title: 'SEO Optimization',
                to: '/features/seo-optimization'
            },
            {
                title: 'Content Analytics',
                to: '/features/content-analytics'
            },
            {
                title: 'Multi-Channel Publishing',
                to: '/features/multi-channel-publishing'
            },
            {
                title: 'Team Collaboration',
                to: '/features/team-collaboration'
            },
            {
                title: 'Content Distribution',
                to: '/features/content-distribution'
            }
        ]
    },
    {
        title: 'Pricing',
        to: '/pricing'
    },
    {
        title: 'Blog',
        to: '/resources/blog'
    }
];

export default sidebarItem;
